import { cn } from '@/lib/cn';

export function ProgressBar({
  value,
  tone = 'brand',
  size = 'md',
  className,
  label,
}: {
  value: number;
  tone?: 'brand' | 'success' | 'warning' | 'danger';
  size?: 'sm' | 'md';
  className?: string;
  label?: string;
}) {
  const pct = Math.min(100, Math.max(0, value));
  const toneClass = {
    brand: 'bg-brand',
    success: 'bg-success',
    warning: 'bg-warning',
    danger: 'bg-danger',
  }[tone];

  return (
    <div
      role="progressbar"
      aria-valuenow={Math.round(pct)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label={label}
      className={cn(
        'overflow-hidden rounded-full bg-surface-3',
        size === 'sm' ? 'h-1.5' : 'h-2',
        className,
      )}
    >
      <div
        className={cn('h-full rounded-full transition-[width]', toneClass)}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
